import { createAction, handleActions } from 'redux-actions';
import { omit, keyBy } from 'lodash';
import { database } from '../../firebase';

export const campaignsRef = database.ref('/campaigns');
const red200 = '#e90e0e';
const grey225 = '#777777';

export enum ACTION_TYPES {
  INSERT_CAMPAIGNS = '@DONACO/INSERT_CAMPAIGNS',
  DELETE_CAMPAIGN = '@DONACO/DELETE_CAMPAIGN',
  CAMPAIGN_DELETED = '@DONACO/CAMPAIGN_DELETED',
  CURRENTLY_EDITING_CAMPAIGN = '@DONACO/CURRENTLY_EDITING_CAMPAIGN',
  SAVING_CAMPAIGN = '@DONACO/SAVING_CAMPAIGN',
  SAVED_CAMPAIGN = '@DONACO/SAVED_CAMPAIGN',
  CLEAR_SAVED_CAMPAIGN = '@DONACO/CLEAR_SAVED_CAMPAIGN',
  CLEAR_CURRENTLY_EDITING_CAMPAIGN = '@DONACO/CLEAR_CURRENTLY_EDITING_CAMPAIGN',
  CURRENTLY_EDITING_CAMPAIGN_IMAGE = '@DONACO/CURRENTLY_EDITING_CAMPAIGN_IMAGE',
  CLEAR_CURRENTLY_EDITING_CAMPAIGN_IMAGE = '@DONACO/CLEAR_CURRENTLY_EDITING_CAMPAIGN_IMAGE',
}
export const imageDetails = {
  logoImgName: '',
  logoImgUrl: '',
  mobileLogoImgName: '',
  mobileLogoImgUrl: ''
};
const defaultState = {
  all: [],
  currentlyEditingCampaign: null,
  imageDetails
};
export const campaignsReducer = handleActions({
  [ACTION_TYPES.INSERT_CAMPAIGNS]: (state, action) => {
    return {
      ...state,
      all: action.payload
    };
  },
  [ACTION_TYPES.CAMPAIGN_DELETED]: (state: any, action: any) => {
    const all = omit(state.all, [ action.payload ]);
    return {
      ...state,
      all
    };
  },
  [ACTION_TYPES.CURRENTLY_EDITING_CAMPAIGN]: (state, action) => {
    const currentlyEditingCampaign: any = action.payload;
    const {logoImgName,  logoImgUrl, mobileLogoImgName, mobileLogoImgUrl} = currentlyEditingCampaign.charities
    return {
      ...state,
      currentlyEditingCampaign: {
        ...currentlyEditingCampaign,
        ...currentlyEditingCampaign.charities,
        payment: currentlyEditingCampaign.payment || currentlyEditingCampaign.charities.payment
      },
      imageDetails: {logoImgName,  logoImgUrl, mobileLogoImgName, mobileLogoImgUrl}
    };
  },
  [ACTION_TYPES.SAVING_CAMPAIGN]: (state, action) => {
    return {
      ...state,
      saving: true
    };
  },
  [ACTION_TYPES.SAVED_CAMPAIGN]: (state, action) => {
    return {
      ...state,
      saving: false,
      saved: true
    };
  },
  [ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CAMPAIGN]: (state, action) => {
    return {
      ...state,
      currentlyEditingCampaign: null,
      imageDetails
    };
  },
  [ACTION_TYPES.CLEAR_SAVED_CAMPAIGN]: (state, action) => {
    return {
      ...state,
      saved: false
    };
  },
  [ACTION_TYPES.CURRENTLY_EDITING_CAMPAIGN_IMAGE]: (state, action) => {
    const imageDetails ={ ...state.imageDetails, ...action.payload};
    const currentlyEditingCampaign = state.currentlyEditingCampaign ? {...state.currentlyEditingCampaign, ...imageDetails} : null
    return {
      ...state,
      currentlyEditingCampaign,
      imageDetails
    };
  },
  [ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CAMPAIGN_IMAGE]: (state, action) => {
    const currentlyEditingCampaign = state.currentlyEditingCampaign ? {...state.currentlyEditingCampaign, ...imageDetails} : null
    return {
      ...state,
      currentlyEditingCampaign,
      imageDetails
    };
  }

}, defaultState);

const insertCampaignsAction = createAction(ACTION_TYPES.INSERT_CAMPAIGNS, (payload) => payload);
const deleteCampaignAction = createAction(ACTION_TYPES.DELETE_CAMPAIGN, (payload) => payload);
const campaignDeletedAction = createAction(ACTION_TYPES.CAMPAIGN_DELETED, (payload) => payload);
export const campaignCurrentlyEditingAction = createAction(ACTION_TYPES.CURRENTLY_EDITING_CAMPAIGN, (payload) => payload);
export const clearCurrentlyEditingCampaignAction = createAction(ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CAMPAIGN);
export const savingCampaignAction = createAction(ACTION_TYPES.SAVING_CAMPAIGN);
export const savedCampaignAction = createAction(ACTION_TYPES.SAVED_CAMPAIGN);
export const clearSavedCampaignAction = createAction(ACTION_TYPES.CLEAR_SAVED_CAMPAIGN);
export const campaignCurrentlyEditingImageAction = createAction(ACTION_TYPES.CURRENTLY_EDITING_CAMPAIGN_IMAGE, (payload) => payload);
export const removeImageForCurrentlyEditingCampaign = createAction(ACTION_TYPES.CLEAR_CURRENTLY_EDITING_CAMPAIGN_IMAGE);

export const extractCampaignFormData = (formData) => {
  const {
    name,
    charities,
    description,
    thankYouMessage,
    oneOffPayments,
    monthlyPayments,
    widgetType,
    topbarColor,
    shadowColor,
    underlineColor,
    textColor,
    hyperlinkColor,
    confirmButtonsColor,
    giftAidOption,
    stripeFeePercentage
  } = formData;
  const oneOff = keyBy(oneOffPayments, (o) => o.figure);
  const monthly = keyBy(monthlyPayments, (o) => o.figure);
  return {
    name,
    charities,
    thankYouMessage: thankYouMessage || '',
    description,
    payment: { oneOff, monthly },
    widgetType: widgetType || '',
    topbarColor: topbarColor || red200,
    shadowColor: shadowColor || red200,
    underlineColor: underlineColor || 'tranparent',
    textColor: textColor || grey225,
    hyperlinkColor: hyperlinkColor || red200,
    confirmButtonsColor: confirmButtonsColor || red200,
    giftAidOption: giftAidOption || false,
    stripeFeePercentage: stripeFeePercentage || 4
  };
};

export const deleteCampaign = (uid) => {
  return (dispatch) => {
    dispatch(deleteCampaignAction(uid));
    dispatch(deleteFromFirebaseCampaign(uid));
  };
};

export const deleteFromFirebaseCampaign = (uid) => {
  return (dispatch) => {
    campaignsRef.child(uid)
      .remove()
      .then(() => {
        dispatch(campaignDeletedAction(uid));
      });
  };
};

export const startListeningForCampaigns = () => {
  return (dispatch) => {
    campaignsRef.on('value', (snapshot) => {
      const campaigns = snapshot.val();
      dispatch(insertCampaignsAction(campaigns));
    });
  };
};
